function selectInspectionReports() {
	$('#reportOutputContainer').hide();
	$('#inspectionReports').show();
	$('#financialReports').hide();
	$('#financialReportTab').removeClass( 'active' );
	$('#reportOutputTab').removeClass( 'active' );
	$('#inspectionReportTab').addClass( 'active' );
}

function selectFinancialReports() {
	$('#reportOutputContainer').hide();
	$('#inspectionReports').hide();
	$('#financialReports').show();
	$('#reportOutputTab').removeClass( 'active' );
	$('#inspectionReportTab').removeClass( 'active' );
	$('#financialReportTab').addClass( 'active' );
}

function selectReportOutput() {
	$('#inspectionReports').hide();
	$('#financialReports').hide();
	$('#reportOutputContainer').show();
	$('#financialReportTab').removeClass( 'active' );
	$('#inspectionReportTab').removeClass( 'active' );
	$('#reportOutputTab').addClass( 'active' );
}

function hideIrEndDateStatus() { $('#ir_updated_end_date').fadeOut('slow'); }
function showIrEndDateStatus() { $('#ir_updated_start_date').hide(); $('#ir_updated_end_date').fadeIn('slow', function() { setTimeout(hideIrEndDateStatus,4000); } ); }

function hideIrStartDateStatus() { $('#ir_updated_start_date').fadeOut('slow'); }
function showIrStartDateStatus() { $('#ir_updated_end_date').hide(); $('#ir_updated_start_date').fadeIn('slow', function() { setTimeout(hideIrStartDateStatus,4000); } ); }

function checkIrDateFromStart() {
	if( Date.parse($('#ir_startdate').val()) > Date.parse($('#ir_enddate').val()) ) {
		$('#ir_enddate').val( $('#ir_startdate').val() );
		showIrEndDateStatus();
	}
}

function checkIrDateFromEnd() {
	if( Date.parse($('#ir_enddate').val()) < Date.parse($('#ir_startdate').val()) ) {
		$('#ir_startdate').val( $('#ir_enddate').val() );
		showIrStartDateStatus();
	}
}

function hideFrEndDateStatus() { $('#fr_updated_end_date').fadeOut('slow'); }
function showFrEndDateStatus() { $('#fr_updated_start_date').hide(); $('#fr_updated_end_date').fadeIn('slow', function() { setTimeout(hideFrEndDateStatus,4000); } ); }

function hideFrStartDateStatus() { $('#fr_updated_start_date').fadeOut('slow'); }
function showFrStartDateStatus() { $('#fr_updated_end_date').hide(); $('#fr_updated_start_date').fadeIn('slow', function() { setTimeout(hideFrStartDateStatus,4000); } ); }

function checkFrDateFromStart() {
	if( Date.parse($('#fr_startdate').val()) > Date.parse($('#fr_enddate').val()) ) {
		$('#fr_enddate').val( $('#fr_startdate').val() );
		showFrEndDateStatus();
	}
}

function checkFrDateFromEnd() {
	if( Date.parse($('#fr_enddate').val()) < Date.parse($('#fr_startdate').val()) ) {
		$('#fr_startdate').val( $('#fr_enddate').val() );
		showFrStartDateStatus();
	}
}

function setupForms() {

	Calendar.setup(
		{
		  inputField  : "ir_startdate",      // id of the input field
		  ifFormat    : "%m/%d/%Y",  // format of the input field
		  button      : "ir_startdate_button",   // trigger for the calendar (button ID)
	      align       : "Br",
	      zIndex      : "8",
	      onUpdate    : checkIrDateFromStart
		}
	);

	Calendar.setup(
		{
		  inputField  : "ir_enddate",      // id of the input field
		  ifFormat    : "%m/%d/%Y",  // format of the input field
		  button      : "ir_enddate_button",   // trigger for the calendar (button ID)
	      align       : "Br",
	      zIndex      : "8",
	      onUpdate    : checkIrDateFromEnd
		}
	);
	
	Calendar.setup(
		{
		  inputField  : "fr_startdate",      // id of the input field
		  ifFormat    : "%m/%d/%Y",  // format of the input field
		  button      : "fr_startdate_button",   // trigger for the calendar (button ID)
	      align       : "Br",
	      zIndex      : "8",
	      onUpdate    : checkFrDateFromStart
		}
	);

	Calendar.setup(
		{
		  inputField  : "fr_enddate",      // id of the input field
		  ifFormat    : "%m/%d/%Y",  // format of the input field
		  button      : "fr_enddate_button",   // trigger for the calendar (button ID)
	      align       : "Br",
	      zIndex      : "8",
	      onUpdate    : checkFrDateFromEnd
		}
	);

	$('#ir_startdate').change(checkIrDateFromStart);
	$('#ir_enddate').change(checkIrDateFromEnd);
	
	$('#fr_startdate').change(checkFrDateFromStart);
	$('#fr_enddate').change(checkFrDateFromEnd);
}
